angular.module('rjmNg.constants')
.constant('metricDataTypes',
  DATA_TYPES: Object.freeze
    nonMonetary: 'value (non-monetary)'
    percentage: 'value (percentage)'
    currency: 'value (currency)'
    seconds: 'value (seconds)'
    bytes: 'value (bytes)'
    raw: 'value (raw)'
)
